
import SmsEdit from "../../../assets/outline/SmsEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SmsEditIcon({ className, dataTestid = "SmsEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SmsEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
